import type { Testimonial } from "@brookbush/types";

import { ArrowUpRightIcon } from "lucide-react";
import Image from "next/image";
import Link from "next/link";
import { RiStarFill } from "react-icons/ri";

import SectionContainer from "~/components/SectionContainer";

interface LandingPageTestimonialsProps {
	testimonials: Testimonial[];
}
const LandingPageTestimonials = ({
	testimonials,
}: LandingPageTestimonialsProps) => {
	return (
		<SectionContainer className="!text-white flex flex-col gap-10 bg-gradient-to-br from-sky-900/50 to-slate-900 dark:from-slate-600 dark:to-slate-900">
			<h2 className="text-center font-bold text-3xl text-white sm:text-4xl xl:text-5xl">
				What our members are saying
			</h2>
			<div className="box-content grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
				{testimonials.map((testimonial) => (
					<div
						className="flex min-h-[25rem] shrink-0 grow-0 basis-[100%] flex-col gap-4 rounded-xl border-sky-500 border-b-8 bg-white px-6 py-5 sm:basis-[calc(50%-1rem)] lg:basis-[calc(33.3%-1rem)] dark:border-sky-600 dark:bg-slate-600/90"
						key={testimonial.title}
					>
						<div className="flex items-center gap-2">
							{[...Array(testimonial.rating)].map((_, index) => (
								<RiStarFill key={index} size={28} className="text-orange-500" />
							))}
						</div>

						<p className="font-semibold text-2xl">{testimonial.title}</p>

						<p className="line-clamp-[8] text-xl">{testimonial.description}</p>

						<div className="mt-auto ml-2 flex items-center gap-2 border-t pt-4 font-medium text-xl">
							{testimonial.author.thumbnail?.url && (
								<div className="relative h-10 w-10 overflow-hidden rounded-full">
									<Image
										src={testimonial.author.thumbnail?.url}
										alt={testimonial.author?.name}
										fill
									/>
								</div>
							)}
							{testimonial.author?.name}
						</div>
					</div>
				))}
			</div>

			<Link
				target="_blank"
				href="https://www.google.com/maps/place/Brookbush+Institute/@40.7470886,-73.9793827,17z/data=!3m1!5s0x89c259042bc3f44d:0xcfda66d9ec348ef6!4m8!3m7!1s0x89c2599677c1a285:0x806ee51940b04b1d!8m2!3d40.7470846!4d-73.9768078!9m1!1b1!16s%2Fg%2F11pck_nqml?entry=ttu"
				className="group mx-auto flex max-w-max items-center gap-1 rounded-full bg-slate-50 px-4 py-1.5 font-medium text-lg text-slate-800 hover:brightness-95 sm:gap-2 sm:px-5 sm:py-2 sm:text-xl dark:bg-slate-700 dark:text-white"
			>
				See Our Google Reviews{" "}
				<ArrowUpRightIcon className="transition-transform group-hover:translate-x-1 group-hover:-translate-y-1" />
			</Link>
		</SectionContainer>
	);
};

export default LandingPageTestimonials;
